<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import moment from 'moment'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
export default {
  methods: {
    ...mapActions({fetchCVsIndependent: 'cv/fetchCVsIndependent'}),
    getRetriedAt(item) {
      if (item.retryType === 1) return moment(item.createdAt).format('DD/MM/YYYY HH:mm')
      return moment(get(item, 'g6Retry2Transactions.0.transactionTime')).format('DD/MM/YYYY HH:mm')
    },
    async onExport() {
      this.$loading.active = true
      const cvs = await this.fetchCVsIndependent({adminQueryType: 'g6Retry', _start: 0, _limit: -1})
      const worksheet = XLSX.utils.json_to_sheet(
        cvs.map(cv => ({
          'Mã hồ sơ': cv.code,
          'Cơ sở': cv.department,
          'Họ tên học sinh': cv.name,
          'Số điện thoại đăng ký': cv.parentUsername,
          'Loại đăng ký': cv.retryType === 1 ? 'Đăng ký mới' : 'Chuyển từ đợt 1',
          'Đăng ký lúc': this.getRetriedAt(cv),
        })),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'hs-k6-dk-thi-lan-2.xlsx')
      this.$loading.active = false
    },
  },
}
</script>
